import * as THREE from 'three';


export default class Lights
{
    constructor(scene, properties)
    {
        this.scene = scene
        this.properties = {
            ...{
                ambientLightColor: 0x404040,
                ambientLightIntensity: 1.5,
                directionalLightColor: 0xffffff,
                directionalLightIntensity: 1,
                directionalLightPosition: new THREE.Vector3(10, 20, 10),
                directionalLightCastShadow: true,
                directionalLightShadowMapSize: new THREE.Vector2(2048, 2048),
                directionalLightShadowCameraLeft: -50,
                directionalLightShadowCameraRight: 50,
                directionalLightShadowCameraTop: 50,
                directionalLightShadowCameraBottom: -50,
                directionalLightShadowCameraNear: 1,
                directionalLightShadowCameraFar: 60, // not too far
            },
            ...properties
        }
    }

    build() {
        const ambientLight = new THREE.AmbientLight(this.properties.ambientLightColor, this.properties.ambientLightIntensity);
        this.scene.add(ambientLight);

        const directionalLight = new THREE.DirectionalLight(this.properties.directionalLightColor, this.properties.directionalLightIntensity);
        directionalLight.position.set(this.properties.directionalLightPosition.x, this.properties.directionalLightPosition.y, this.properties.directionalLightPosition.z);
        directionalLight.castShadow = this.properties.directionalLightCastShadow;
        directionalLight.shadow.mapSize.width = this.properties.directionalLightShadowMapSize.width;
        directionalLight.shadow.mapSize.height = this.properties.directionalLightShadowMapSize.height;
        directionalLight.shadow.camera.left = this.properties.directionalLightShadowCameraLeft;
        directionalLight.shadow.camera.right = this.properties.directionalLightShadowCameraRight;
        directionalLight.shadow.camera.top = this.properties.directionalLightShadowCameraTop;
        directionalLight.shadow.camera.bottom = this.properties.directionalLightShadowCameraBottom;
        directionalLight.shadow.camera.near = this.properties.directionalLightShadowCameraNear;
        directionalLight.shadow.camera.far = this.properties.directionalLightShadowCameraFar;

        // helper light
        // const directionalLightHelper = new THREE.DirectionalLightHelper(directionalLight);
        // this.scene.add(directionalLightHelper);

        // helper shadow camera
        // const directionalLightShadowHelper = new THREE.CameraHelper(directionalLight.shadow.camera);
        // this.scene.add(directionalLightShadowHelper);

        this.scene.add(directionalLight);
    }
}
